import React, { useEffect, useState } from 'react';
import styles from './Form.module.css';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { TextInput } from '@mantine/core';

const Form = ({ profile, form }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.oneLine}>
        <TextInput
          className={cn(styles.input)}
          label={t('name.label')}
          key={form.key('name')}
          {...form.getInputProps('name')}
        />

        <TextInput
          className={cn(styles.input, 'disabled')}
          disabled
          label={t('email.label')}
          key={form.key('email')}
          {...form.getInputProps('email')}
        />
      </div>
    </div>
  )
}

export default Form;
